import { useCallback } from 'react'
import { Resume } from 'packages/types'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useUpdateSimpleField } from './useUpdateSimpleField'

const useUpdateSimpleShokomuField = (fieldName: keyof Resume) => {
  const fieldValue = useTypedSelector(state => state.resumeEditor.resume?.[fieldName])
  const { updateSimpleField } = useUpdateSimpleField()

  const updateField = useCallback(
    (value: string | number | boolean) => {
      updateSimpleField({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        name: fieldName as any,
        value,
        debounce: true,
      })
    },
    [fieldName, updateSimpleField],
  )

  return {
    fieldName,
    fieldValue: fieldValue ?? '',
    updateField,
  }
}

export { useUpdateSimpleShokomuField }
